import { useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
const meta = {
  es: {
    title: "GRANSACA.COM | Granzonera y Agregados San Antonio, C.A. - Agregados para la construcción en Venezuela",
    description: "Producción y comercialización de agregados para la construcción en Venezuela: arena, polvillo, piedra 3/4, piedra 7/8, granzón, base y material de relleno. Planta trituradora moderna y suministro confiable."
  },
  en: {
    title: "GRANSACA.COM | Granzonera y Agregados San Antonio, C.A. - Construction aggregates in Venezuela",
    description: "Production and supply of construction aggregates in Venezuela: sand, stone dust, 3/4 stone, 7/8 stone, granzón, base and fill material. Modern crushing plant and reliable supply."
  }
};
const keywords = "Granzonera, Agregados para construcción, Materiales de construcción, Arena, Polvillo, Piedra 3/4, Piedra 7/8, Granzón, Base, Planta trituradora, Trituración de piedra, Agregados pétreos, Cantera, Venezuela";
function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Keeps document title + meta in sync with the active language (SEO).
export function Seo() {
  const {
    lang
  } = useLanguage();
  useEffect(() => {
    const m = meta[lang];
    document.title = m.title;
    document.documentElement.lang = lang;
    setMeta("description", m.description);
    setMeta("keywords", keywords);
  }, [lang]);
  return null;
}